import PropTypes from "prop-types";

const ConditionalWrapper = ({ condition, wrapper, altWrapper, children }) =>
  condition ? wrapper(children) : (altWrapper ? altWrapper(children) : children);

ConditionalWrapper.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	condition: PropTypes.bool,
	wrapper: PropTypes.elementType,
	altWrapper: PropTypes.elementType,
}

export default ConditionalWrapper;